import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';

export const helpSalesDashboard: ISidebarHelp = {
	title: 'Dashboard de Vendas',
	firstParagraph: `Este dashboard permite o acompanhamento da Cadência de Vendas semanal sempre levando em consideração a demanda (plano restrito), meta de vendas e histórico. Use os filtros de data para selecionar os dados desejados.`,
	secondParagraph: `Para analisar as vendas por canais de venda utilize como auxiliar a tabela, nela é possível comparar sua meta, carteira boa, faturado e forecast.`,
	thirdParagraph: `O gráfico de cadência de vendas se refere aos dias do mês selecionado no filtro, sendo possível comparar sua cadência de vendas com o andamento do mês atual, mês passado e o histórico.`,
	firstLink: URL_CT360,
	secondLink: URL_FALE_CONOSCO,
};
